import { IdentityFormTypes } from '@Components/Identity/IdentityFormTypeSwitcher';
import { getCombinedScheme } from '@Lib/Identity/scheme/identityNonUsFormScheme';
import { validateNationalIdByCountry } from '@Lib/Identity/scheme/validateNationalIdByCountry';

import type { Country } from '@Types/country.ts';

export const useDynamicIdentityScheme = (
  supportedCountries: Country[],
  formType: IdentityFormTypes,
  owner?: boolean
) => {
  const getScheme = () => {
    return getCombinedScheme(formType, owner).superRefine((data: Record<string, unknown>, ctx) => {
      if (formType === IdentityFormTypes.nonUs) {
        validateNationalIdByCountry(data, ctx, supportedCountries);
      }
    });
  };

  return { scheme: getScheme() };
};
